"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _recharts = require("recharts");
var _DoughnutLabel = _interopRequireDefault(require("./DoughnutLabel"));
var _Doughnut = _interopRequireDefault(require("./Doughnut.style"));
var _Legend = _interopRequireDefault(require("../../legend/Legend"));
var _helpers = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Doughnut = /*#__PURE__*/function (_Component) {
  _inherits(Doughnut, _Component);
  var _super = _createSuper(Doughnut);
  function Doughnut(props) {
    var _this;
    _classCallCheck(this, Doughnut);
    _this = _super.call(this, props);
    var colorValues = R.values(props.colors);
    var data = props.data,
      dataKey = props.dataKey;
    _this.state = {
      processedData: (0, _helpers.processCatValues)((0, _helpers.mergeDataWithColor)(data, colorValues), dataKey)
    };
    return _this;
  }
  _createClass(Doughnut, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        dataKey = _this$props.dataKey,
        labelKey = _this$props.labelKey,
        currency = _this$props.currency,
        legend = _this$props.legend,
        onItemClick = _this$props.onItemClick,
        _highlightActive = _this$props.highlightActive,
        _removeHighlight = _this$props.removeHighlight,
        prefixId = _this$props.prefixId,
        idKey = _this$props.idKey,
        legendProps = _this$props.legendProps,
        paddingAngle = _this$props.paddingAngle,
        pageSize = _this$props.pageSize,
        minWidth = _this$props.minWidth,
        defaultLabel = _this$props.defaultLabel,
        withPagination = _this$props.withPagination,
        highlightedCategoryIndex = _this$props.highlightedCategoryIndex;
      var _this$state = this.state,
        processedData = _this$state.processedData,
        filledColors = _this$state.filledColors;
      var pieProcessedData = (0, _helpers.filterEmptyValues)(processedData);
      var PieLegend = this.props.legendComponent ? this.props.legendComponent : _Legend["default"];
      var hasTwoOrMore = R.length(pieProcessedData) > 1;
      var activeIndex = R.findIndex(R.propEq('orderIndex', highlightedCategoryIndex))(pieProcessedData);
      return /*#__PURE__*/_react["default"].createElement(_Doughnut["default"], {
        legend: true,
        minWidth: minWidth
      }, /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
        width: "100%",
        height: height,
        className: "doughnut-chart"
      }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, {
        id: "".concat(prefixId, "Chart")
      }, /*#__PURE__*/_react["default"].createElement(_recharts.Pie, {
        isAnimationActive: false,
        activeIndex: R.findIndex(R.propEq('orderIndex', highlightedCategoryIndex))(pieProcessedData),
        activeShape: function activeShape(props) {
          return Doughnut.renderDoughnutLabel({
            props: props,
            filledColors: filledColors
          });
        },
        data: pieProcessedData,
        dataKey: dataKey,
        nameKey: labelKey,
        innerRadius: "75%",
        outerRadius: "100%",
        onMouseOver: _highlightActive,
        onFocus: _highlightActive,
        onMouseLeave: _removeHighlight,
        onBlur: _removeHighlight,
        onClick: function onClick(activeItem) {
          var categ = R.prop(idKey, activeItem);
          var callback = onItemClick(categ);
          if (typeof callback === 'function') {
            callback();
          }
        },
        startAngle: 90,
        endAngle: -270,
        paddingAngle: hasTwoOrMore ? paddingAngle : 0
      }, pieProcessedData.map(function (entry, index) {
        return /*#__PURE__*/_react["default"].createElement(_recharts.Cell, (0, _helpers.getCellOptions)({
          entry: entry,
          labelKey: labelKey,
          activeIndex: highlightedCategoryIndex !== -1 && activeIndex === -1 ? null : activeIndex,
          index: index
        }));
      }), highlightedCategoryIndex === -1 ? /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
        value: defaultLabel,
        position: "center"
      }) : ''))), legend && /*#__PURE__*/_react["default"].createElement(PieLegend, _extends({
        pageSize: pageSize,
        highlightActive: function highlightActive(item) {
          return _highlightActive(item);
        },
        removeHighlight: function removeHighlight(item) {
          return _removeHighlight(item);
        },
        activeIndex: highlightedCategoryIndex,
        className: "doughnut-legend",
        items: processedData,
        idKey: idKey,
        labelKey: labelKey,
        colors: R.pluck('color', processedData),
        currency: currency,
        onItemClick: onItemClick,
        prefixId: prefixId,
        withPagination: withPagination
      }, legendProps)));
    }
  }]);
  return Doughnut;
}(_react.Component);
_defineProperty(Doughnut, "renderDoughnutLabel", function (_ref) {
  var props = _ref.props,
    filledColors = _ref.filledColors;
  return /*#__PURE__*/_react["default"].createElement(_DoughnutLabel["default"], _extends({}, props, {
    colors: filledColors
  }));
});
Doughnut.defaultProps = {
  defaultLabel: '',
  pageSize: 10,
  paddingAngle: 3,
  dataKey: 'value',
  labelKey: 'label',
  idKey: 'categoryLevel1Id',
  height: 220,
  currency: 'EUR',
  legend: false,
  locale: 'en-GB',
  onItemClick: R.identity,
  highlightActive: R.identity,
  removeHighlight: R.identity,
  highlightedCategoryIndex: -1,
  offset: 0,
  prefixId: null,
  legendComponent: null,
  legendProps: {},
  minWidth: null,
  withPagination: false
};
Doughnut.propTypes = {
  defaultLabel: _propTypes["default"].string,
  pageSize: _propTypes["default"].number,
  paddingAngle: _propTypes["default"].number,
  /** locale used to change the way the value is displayed */
  locale: _propTypes["default"].string,
  /** currency to be displayed together with the value. Compliant with https://en.wikipedia.org/wiki/ISO_4217  */
  currency: _propTypes["default"].string,
  /** Flag to attach the legend to the doughnut */
  legend: _propTypes["default"].bool,
  /** Name of the value key of the data */
  dataKey: _propTypes["default"].string,
  /** Name of the label key of the data */
  labelKey: _propTypes["default"].string,
  /** Name of the id key of the data */
  idKey: _propTypes["default"].string,
  /** height of the doughnut */
  height: _propTypes["default"].number,
  /** color map */
  colors: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  /** data object: Fields of interest: label, value, percent(if needed) */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** action to be triggered on clicking a pie item */
  onItemClick: _propTypes["default"].func,
  highlightActive: _propTypes["default"].func,
  removeHighlight: _propTypes["default"].func,
  highlightedCategoryIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({})]),
  offset: _propTypes["default"].number,
  /** id to prefix elements */
  prefixId: _propTypes["default"].string,
  legendComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  legendProps: _propTypes["default"].shape({}),
  minWidth: _propTypes["default"].number,
  withPagination: _propTypes["default"].bool
};
Doughnut.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "renderDoughnutLabel",
    "docblock": null,
    "modifiers": ["static"],
    "params": [{
      "name": "{ props, filledColors }",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Doughnut",
  "props": {
    "defaultLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "pageSize": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "paddingAngle": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "dataKey": {
      "defaultValue": {
        "value": "'value'",
        "computed": false
      },
      "description": "Name of the value key of the data",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "labelKey": {
      "defaultValue": {
        "value": "'label'",
        "computed": false
      },
      "description": "Name of the label key of the data",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "idKey": {
      "defaultValue": {
        "value": "'categoryLevel1Id'",
        "computed": false
      },
      "description": "Name of the id key of the data",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "220",
        "computed": false
      },
      "description": "height of the doughnut",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "currency": {
      "defaultValue": {
        "value": "'EUR'",
        "computed": false
      },
      "description": "currency to be displayed together with the value. Compliant with https://en.wikipedia.org/wiki/ISO_4217",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "legend": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to attach the legend to the doughnut",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "locale": {
      "defaultValue": {
        "value": "'en-GB'",
        "computed": false
      },
      "description": "locale used to change the way the value is displayed",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onItemClick": {
      "defaultValue": {
        "value": "R.identity",
        "computed": true
      },
      "description": "action to be triggered on clicking a pie item",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "highlightActive": {
      "defaultValue": {
        "value": "R.identity",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "removeHighlight": {
      "defaultValue": {
        "value": "R.identity",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "highlightedCategoryIndex": {
      "defaultValue": {
        "value": "-1",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "shape",
          "value": {}
        }]
      },
      "required": false
    },
    "offset": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "prefixId": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "id to prefix elements",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "legendComponent": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "legendProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "minWidth": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "withPagination": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "colors": {
      "description": "color map",
      "type": {
        "name": "union",
        "value": [{
          "name": "shape",
          "value": {}
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": true
    },
    "data": {
      "description": "data object: Fields of interest: label, value, percent(if needed)",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    }
  }
};
var _default = Doughnut;
exports["default"] = _default;